<template>
  <div style="display:inline-block">
    <el-button size="small" type="success" @click="showDialog">创建生产日报单</el-button>
    <el-dialog title="创建生产日报单" :visible.sync="dialogVisible" width="1150px">
      <el-form :inline="true" ref="addForm" :model="addForm">
        <el-form-item label="日期" prop="produce_date" label-width="80px">
          <el-date-picker
            size="small"
            v-model="addForm.produce_date"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="操作员" prop="operator">
          <el-select
          placeholder="选择操作员"
          v-model="addForm.operator"
          size="small"
          clearable
          filterable
        >
          <el-option v-for="(item,index) in $store.state.operatorList" :key="index" :label="item" :value="item"></el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="生产单位" prop="department">
          <el-select
          placeholder="选择生产单位"
          v-model="addForm.department"
          size="small"
          clearable
          filterable
        >
          <el-option v-for="(item,index) in $store.state.departmentList" :key="index" :label="item" :value="item"></el-option>
        </el-select>
        </el-form-item>
        <el-table :data="addForm.productList" style="width:1050px;margin-left:30px" :border="true">
          <el-table-column align="center" prop="product_name" label="产品名称"></el-table-column>
          <el-table-column align="center" prop="product_size" label="产品规格"></el-table-column>
          <el-table-column align="center" label="加工步骤" width="208px">
            <template slot-scope="scope">
              <el-form-item :prop="`productList.${scope.$index}.process`">
                <el-select style="width:140px" v-model="addForm.productList[scope.$index].process" filterable clearable size="small" @change="desc=>{processChange(desc, scope.$index)}">
                  <el-option v-for="(processItem,index) in scope.row.processesList" :key="index" :label="processItem.description" :value="processItem.description"></el-option>
                </el-select>
                <i style="margin-left:10px;font-size:20px;vertical-align:middle;cursor:pointer" class="el-icon-circle-plus-outline" @click="addForm.productList.splice(scope.$index,0,JSON.parse(JSON.stringify(scope.row)))"></i>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center" label="单价">
            <template slot-scope="scope">
              <el-form-item :prop="`productList.${scope.$index}.price`">
                <el-input v-model="addForm.productList[scope.$index].price" clearable size="small"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="produce_hour" label="作业时间">
            <template slot-scope="scope">
              <el-form-item
                :prop="`productList.${scope.$index}.produce_hour`"
                :rules="{ pattern: /^[0-9]*(\.[0-9]{1,2})?$/, message: '请输入数字(最多两位小数)', trigger: 'blur' }"
              >
                <el-input
                  size="small"
                  v-model="addForm.productList[scope.$index].produce_hour"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center" label="实际产量">
            <template slot-scope="scope">
              <el-form-item
                :prop="`productList.${scope.$index}.produce_count`"
                :rules="{ pattern: /^[0-9]*(\.[0-9]{1,3})?$/, message: '请输入数字(最多三位小数)', trigger: 'blur' }"
              >
              <el-input
                  size="small"
                  v-model="addForm.productList[scope.$index].produce_count"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column align="center" label="备注">
            <template slot-scope="scope">
              <el-form-item
                :prop="`productList.${scope.$index}.remark`"
              >
              <el-input
                  size="small"
                  v-model="addForm.productList[scope.$index].remark"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="dialogVisible=false">取消</el-button>
        <el-button size="small" :disabled="buttonDisable" type="primary" @click="addProduce">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addProduceReport } from '../api/index'
export default {
  props: ['selectList'],
  data () {
    return {
      dialogVisible: false,
      buttonDisable: false,
      addForm: {
        operator: '',
        department: '',
        produce_date: new Date(new Date().getTime() - 86400000).format('yyyy-MM-dd'),
        productList: []
      }
    }
  },
  watch: {
    selectList: {
      handler (selectList) {
        this.addForm.productList = selectList.map(item => {
          return {
            product_name: item.product_name,
            product_size: item.product_size,
            process: '',
            price: '',
            produce_hour: '',
            produce_count: '',
            processesList: item.process,
            remark: ''
          }
        })
      }
    }
  },
  methods: {
    processChange (desc, index) {
      let currentProcess = this.$store.state.processesList.find(ele => ele.name === desc)
      if (currentProcess && currentProcess.price) {
        this.addForm.productList[index].price = currentProcess.price
      } else {
        this.addForm.productList[index].price = null
      }
    },
    showDialog () {
      if (this.selectList.length === 0) {
        this.$message.error('请至少选择一个产品')
        return
      }
      this.dialogVisible = true
    },
    addProduce () {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          // let params = JSON.parse(JSON.stringify(this.addForm))
          // params.productList.for
          this.buttonDisable = true
          addProduceReport(this.addForm).then(res => {
            this.buttonDisable = false
            if (res.data.status === 200) {
              this.$message.success(res.data.msg)
              this.dialogVisible = false
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    }
  }
}
</script>

<style>
</style>
